import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const benefits = [
    "Protocolos Científicamente Probados",
    "Personal Altamente Capacitado",
    "Resultados Garantizados"
  ];

  return (
    <section 
      id="hero" 
      className="min-h-screen flex items-center pt-20 bg-white"
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <h1 
              className="text-5xl lg:text-6xl font-bold leading-tight text-gray-900"
            >
              Transformamos Sus Espacios en Ambientes Impecables
            </h1>

            <p className="text-xl text-gray-600 leading-relaxed">
              Soluciones profesionales de limpieza que superan expectativas. 
              Metodología científica y resultados medibles.
            </p>

            {/* Benefits List */}
            <div className="space-y-4 pt-4">
              {benefits.map((benefit, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle2 
                    size={20} 
                    className="text-[#2E75B6] flex-shrink-0"
                  />
                  <span className="text-gray-700">
                    {benefit}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative lg:h-[550px] h-[400px]">
            <div className="absolute inset-0 rounded-lg overflow-hidden">
              <img
                src="https://customer-assets.emergentagent.com/job_merx-landing/artifacts/o8nem7g2_merx-.jpg"
                alt="Equipo profesional MERX"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
